module.exports = __webpack_public_path__ + "static/media/currency_gif.7eab8a84.gif";